export const module = {
  info: {
    name: 'jikatel-server-clean-operation',
    caption: 'Jikatel Operations'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Operations',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-server-clean-operation',
    children: [
      {
        caption: 'List Operations',
        icon: 'el-icon-more-outline',
        routeName: 'module->jikatel-server-clean-operation->list'
      }
    ]
  }
}

export default module
